<template>
<div class="chapter">
<div class="inner_page">
<p><a id="als"></a></p>
<div class="fmhT">ALSO BY PENNY VINCENZI</div>
<div class="ctag1"><i>No Angel</i></div>
<div class="ctag1"><i>Something Dangerous</i></div>
<div class="ctag1"><i>Almost a Crime</i></div>
<div class="ctag1"><i>The Dilemma</i></div>
<div class="ctag1"><i>An Outrageous Affair</i></div>
<div class="ctag1"><i>Sheer Abandon</i></div>
<div class="ctag1"><i>An Absolute Scandal</i></div>
<div class="ctag1"><i>Forbidden Places</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590208007_oeb_als_r1.vue?22bbe03d